import { createContext, ReactNode } from 'react';

export type ActivateDrawer = ({ content, drawerWidth }: { content: ReactNode; drawerWidth?: number }) => void;

interface DrawerContextValue {
  drawerWidth: number;
  activateDrawer: ActivateDrawer;
  deactivateDrawer: () => void;
}

const DrawerContext = createContext<DrawerContextValue | null>(null);

export default DrawerContext;
